
import {Box, Skeleton} from "@mui/material";

export const NoResults = ({searchQuery}: { searchQuery: string | undefined }) => (
    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', p: 4, flexGrow: 1}}>
        <Skeleton animation={'wave'} width={100} height={100}/>
        <div>Sorry, we could not find results for <em>{searchQuery}</em>.</div>
    </Box>
)